module.exports = __webpack_public_path__ + "img/slide3.e5d7488c.jpg";